<template lang="pug">
    header
        .logo-wrapper-mobile.is-hidden-desktop
            img.upload#logo(v-if="logo && logo.id" v-lazy="image" title="logo" rel="noopener")
            img.base#logo(v-else src="@/assets/mit-logo.svg")

        button.hamburger.hamburger--3dy(type="button" :class="{ 'is-active': sidebar }" @click="toggleSidebar")
            span.hamburger-box
                span.hamburger-inner

        .logo-wrapper-desktop.is-hidden-touch
            img.upload#logo(v-if="logo && logo.id" v-lazy="image" title="logo" rel="noopener")
            img.base#logo(v-else src="@/assets/mit-logo.svg")

        .container.is-hidden-touch
            .columns
                .main-menu-wrapper.column
                    nav#main-menu.is-pulled-left
                        tree-menu(:items="items" :max-depth="3" :delay="400")
                    //- a.search.icon.is-large(href="#" @click.prevent="openSearch")
                        i.fas.fa-search

        .subheader
            transition(name="slide-header")
                .infobox-wrap(v-if="header")
                    .container
                        .calendar.is-hidden-touch
                            calendar(
                                is-dark
                                color="red"
                                :locale="calendar.locale"
                                :attributes="calendar.attributes"
                            )
                                template(v-slot:day-popover="{ attributes, day, dayTitle }")
                                    .vc-day-popover-header
                                        //- | {{ dayTitle }}
                                        //- 'EEEEEE, MMM MM, yyyy'
                                        | {{ day.date | formatDate('PPPP') }}
                                    calendar-popover-row(
                                        v-for="attribute in attributes"
                                        :key="attribute.key"
                                        :attribute="attribute"
                                    )
                            h3.is-size-6.has-text-white Veranstaltungen und Termine
                        .teasers
                            .teaser(v-for="teaser in teasers" :style="style")
                                Teaser(:teaser="teaser" display="card")
            .socialIcons.has-text-centered
                a(v-if="urls.fb" :href="urls.fb" target="_blank")
                    span.icon.is-medium.has-text-white
                        i.fab.fa-lg.fa-facebook-f
                a(v-if="urls.yt" :href="urls.yt" target="_blank")
                    span.icon.is-medium.has-text-white
                        i.fab.fa-lg.fa-youtube
                a(v-if="urls.twitter" :href="urls.twitter" target="_blank")
                    span.icon.is-medium.has-text-white
                        i.fab.fa-lg.fa-twitter
        a.subHeadertoggleBtn(@click="toggleHeader")
</template>

<script>

import _ from 'lodash'
import Color from 'color'
import { fromUnixTime, format } from 'date-fns'
import { de } from 'date-fns/locale'
import { mapGetters, mapMutations, mapActions } from 'vuex'
import store from '@/store'

import NestedSet from '@/nested-set-lib'
import Teaser from './Teaser'
import CalendarPopoverRow from './Partials/CalendarPopoverRow'

export default {
    name: 'Header',
    data() {
        return {
            calendar: {
                locale: { id: 'de', masks: { weekdays: 'WW' } },
                attributes: [
                    {
                        key: 'today',
                        highlight: true,
                        dates: new Date()
                    }
                ]
            },
            facebookLink: {
                MIT_NRW: 'https://www.facebook.com/MITNRW',
                MIT_LANGENFELD: 'https://www.facebook.com/mitLangenfeld/',
                MIT_KREISMETTMANN: 'https://www.facebook.com/MITNRW'
            },
            twitterLink: {
                MIT_NRW: 'https://twitter.com/mit_nrw',
                MIT_LANGENFELD: 'https://twitter.com/mit_nrw',
                MIT_KREISMETTMANN: 'https://twitter.com/mit_nrw'
            
            },
            youtubeLink: {
                MIT_NRW: 'https://www.youtube.com/user/MITNRW',
                MIT_LANGENFELD: 'https://www.youtube.com/user/MITNRW',
                MIT_KREISMETTMANN: 'https://www.youtube.com/user/MITNRW'
            }
        }
    },
    components: {
        Teaser,
        CalendarPopoverRow
    },
    filters: {
        formatDate(value, template = 'dd.MM.yyyy') {
            return format(value, template, { locale: de })
        }
    },
    computed: {

        baseUrl() {
            return window.location.host
        },
        urls() {
            switch (this.baseUrl) {
                case 'mit-langenfeld.de.37-61-201-233.vanameland05.de':
                case 'mit-langenfeld.de':
                case 'www.mit-langenfeld.de':
                    return {fb: this.facebookLink.MIT_LANGENFELD, twitter: this.twitterLink.MIT_LANGENFELD , yt: this.youtubeLink.MIT_LANGENFELD }
                case 'mit-kreismettmann.de.37-61-201-233.vanameland05.de':
                case 'mit-kreismettmann.de':
                case 'www.mit-kreismettmann.de':
                    return {fb: this.facebookLink.MIT_KREISMETTMANN, twitter: this.twitterLink.MIT_KREISMETTMANN , yt: this.youtubeLink.MIT_KREISMETTMANN }
                case '127.0.0.1:8085':
                case 'mit-nrw.de.37-61-201-233.vanameland05.de':
                case 'mit-nrw.de':
                case 'www.mit-nrw.de':
                    return {fb: this.facebookLink.MIT_NRW, twitter: this.twitterLink.MIT_NRW , yt: this.youtubeLink.MIT_NRW }
                default:
                    return {fb: false, twitter: false, yt: false}
            }
        },

        items() {
            const menu = this.menus.find(menu => menu.key === 'main-menu')
            let items = _.get(menu, 'menuItems') || []
            items = _.cloneDeep(items)

            if (items.length) {
                return NestedSet.createTree(items)
            }

            return items
        },
        image() {
            const storageRoute = _.trim(`${process.env.VUE_APP_API_ENDPOINT}${process.env.VUE_APP_API_PUBLIC_STORAGE_ROUTE}`, '/')

            const fit = 'fit=fill&w=740&h=142'

            let width = this.logo.width
            let height = this.logo.height

            return {
                src: `${storageRoute}/images/${this.logo.id}/${this.logo.name}?${fit}`,
                error: `${storageRoute}/images/${this.logo.id}/${this.logo.name}?${fit}&preview=greyscale`,
                loading: `${storageRoute}/images/${this.logo.id}/${this.logo.name}?${fit}&preview=blur`,
                width,
                height,
            }
        },
        loading() {
            return _.get(this.headernews, 'teasers.loading')
        },
        teasers() {
            return _.get(this.headernews, 'teasers.items') || []
        },
        pageInfo() {
            return _.get(this.headernews, 'teasers.pageInfo')
        },
        ...mapGetters({
            logo: 'logo',
            menus: 'menus',
            sidebar: 'sidebar',
            header: 'header',
            CMS: 'CMS',
            headernews: 'currentPage/headerNews'
        })
    },
    methods: {
        openSearch() {
            // TODO
            // console.log('open search bar');
         },
        toggleSidebar() {
            this.updateSidebarVisibility(! this.sidebar)
        },
        toggleHeader() {
            this.updateHeaderVisibility(! this.header)
        },
        style() {
            return {
                width: `calc(${100 / 2}% - 20px)`
            }
        },
        ...mapMutations({
            updateSidebarVisibility: 'updateSidebarVisibility',
            updateHeaderVisibility: 'updateHeaderVisibility',
            updateTeasersLoading: 'currentPage/updateCategoryPostTeasersLoadingIntoHeader',
            insertTeasers: 'currentPage/insertCategoryPostTeasersIntoHeader',
        }),
        ...mapActions('currentPage', {
            fetchTeasers: 'fetchCategoryPostTeasers',
        }),
    },

    mounted() {
        const teasers = { loading: true, pagination: {} }
        this.insertTeasers({ teasers })

        const cms = this.CMS.id
        const category = this.CMS.categories.find(category => category.key === 'headerNews')

        if (category) {
            const payload = {
                pageInfo: {
                    currentPage: 1,
                    perPage: 2,
                },
                filters: [{
                    key: 'categories',
                    in: [ category.id ]
                }, {
                    key: 'cms',
                    match: cms,
                }],
            }

            this.fetchTeasers(payload)
                .then(teasers => this.insertTeasers({ teasers }))
        } else {
            this.updateTeasersLoading({ s: this.s, value: false })
        }

        // init calendar

        if (this.CMS.events && this.CMS.events.length) {
            this.CMS.events.forEach(event => {
                if (event.slots && event.slots.length) {
                    let hex = event.color || _.get(event, 'category.color')

                    let dot
                    if (hex) {
                        let color = Color(hex)
                        // if (color.isDark()) color = color.lighten(0.4)

                        const lightness = color.lightness()
                        if (lightness < 75) color = color.lightness(75)

                        dot = {
                            style: {
                                color: hex,
                                background: color.rgb().string()
                            }
                        }
                    } else {
                        dot = 'red'
                    }

                    // let dates = []
                    event.slots.forEach(slot => {
                        const start = fromUnixTime(slot.start_at)
                        const end = fromUnixTime(slot.end_at)
                        // dates.push({ start, end })

                        this.calendar.attributes.push({
                            key: slot.id,
                            dot,
                            dates: { start, end },
                            popover: {
                                label: event.name,
                                visibility: 'hover',
                                isInteractive: true,
                            },
                            customData: { slot }
                        })
                    })
                }
            })
        }
    }
}
</script>

<style lang="sass" scoped>

    @import "~bulma/sass/utilities/mixins";
    @import '~@/assets/sass/variables';

    header
        // padding-top: 50px
        // padding-bottom: 50px
        background-color: $lightgray
        //border-bottom: 1px solid #dddddd
        .name
            padding-top: 15px
        .base#logo
            height: 90px
            padding-top: 25px
            right: 0
            top: 0  
        .upload#logo
            right: 20px
            top: 28px
            max-width: 370px
            max-height: 71px
            height: auto
            width: 100%

        .hamburger
            height: 55px
            outline: none
            +desktop
                display: none
        .logo-wrapper-mobile
            position: absolute
            top: 5px
            right: 0
            .base#logo
                padding-top: 0
                width: 240px
                height: auto
            .upload#logo
                padding-top: 1px
                padding-right: 8px
                width: 240px
                height: auto

        .logo-wrapper-desktop
            position: relative
            #logo
                position: absolute
                  

        .container
            margin-top: 0.75rem
            height: 130px
            .columns
                height: 100%
                .main-menu-wrapper.column
                    a.search
                        height: 54px
                        width: 54px
                        &:hover
                            background-color: #e30018
                            color: #fff

        .main-menu-wrapper
            margin-top: auto
            padding-bottom: 0
            .navbar-item
                // color: #222222 !important

            #main-menu
                z-index: 10
                & ::v-deep
                    ul
                        &.tree-menu
                            & > li
                                transition: background-color .3s ease
                                &:not(.full-width)
                                    position: relative
                                & > .tree-item
                                    height: 51px
                                    a
                                        text-decoration: none
                                        font-weight: 600
                                        font-size: 14px
                                        text-transform: uppercase
                                        color: #222222
                                        padding: 15px
                                        display: block
                                        transition: color .3s ease
                                &.hover
                                    background-color: #e30018
                                    & > .tree-item a
                                        color: #fff
                                &.has-children
                                    & > .tree-item a
                                        &:after
                                            display: none
                                            font-family: 'Font Awesome 5 Solid'
                                            content: '\f107'
                                            // padding-left: 6px
                                            // transition: color .3s ease
                                        svg
                                            color: inherit
                                            margin-right: 6px
                                            // transition: color .3s ease

                                li
                                    // padding: 0 9px
                                    width: 100%
                                    background-color: #e30018
                                    display: block

                                    & > .tree-item a
                                        font-weight: normal
                                        color: #fff
                                        display: inline-block
                                        max-width: 320px
                                        overflow: hidden
                                        text-overflow: ellipsis
                                        white-space: nowrap
                                        &:before
                                            display: none
                                            font-family: 'Font Awesome 5 Solid'
                                            content: "\f054"
                                        svg
                                            color: inherit
                                            margin-right: 6px
                                            // transition: color .3s ease


                                    &.hover
                                        background-color: #fff
                                        & > .tree-item a
                                            color: #222222
                                            &:before
                                                color: #222222
                                li.has-children
                                    padding-right: 20px
                                    &:after
                                        font-family: 'Font Awesome 5 Solid'
                                        content: "\f078"
                                        display: none
                                    svg.fa-chevron-down 
                                        right: 10px
                                        top: 18px
                                        color: #fff
                                        position: absolute

                                    


                    & > ul
                        &.tree-menu
                            & > li
                                // padding: 0 9px 33px 9px
                                display: inline-block
                                & > .tree-item a
                                    padding: 16px 12px 12px 12px
                                    border-bottom: 5px solid transparent
                                    &.router-link-exact-active
                                        color: #e30018
                                &.hover > .tree-item a.router-link-exact-active
                                    color: #fff
                                & > ul
                                    &.tree-menu
                                        position: absolute
                                        left: 0
                                        top: 100%
                                        display: flex
                                        flex-direction: column
                                        min-width: 100%
                                        z-index: 100
                                        box-shadow: 0px 5px 10px 0px rgba(0,0,0,0.3)
                                        &.full-width
                                            background: #e30018
                                            width: 100%
                                            columns: 3
                                            column-gap: 0
                                            display: block
                                            +widescreen
                                                columns: 4
                                            li > .tree-item
                                                width: 100%
                                                a
                                                    max-width: initial
                            ul ul
                                min-width: 200px
                                margin-bottom: 9px
                                position: absolute
                                left: 100%
                                top: 0
                                // box-shadow: 0px 5px 10px 0px rgba(0,0,0,0.3)
                                li > .tree-item a
                                    // padding: 10px 15px
                                    // font-size: .8rem
                                    // &:before
                                    //     font-size: 0.5rem
                                    //     position: relative
                                    //     top: -1px

                    .show-enter-active, .show-leave-active
                        transition: opacity 0.3s ease, transform 0.3s ease
                        transform-origin: left center
                    .show-enter, .show-leave-to
                        opacity: 0
                        transform: translateY(6px)
    .subheader
        width: 100%
        min-height: 180px
        box-shadow: inset 0 20px 20px -20px rgba(0,0,0,0.8)
        background-color: $darkgray
        background-image: url('~@/assets/mitheader.svg')
        background-size: 100% auto
        background-repeat: no-repeat
        background-position: bottom center

        +tablet-only
            min-height: 100px
        +mobile
            min-height: 100px

        .infobox-wrap
            .container
                display: flex
                padding-top: 30px
                color: #fff
                margin-top: 0
                // height: max-content
                height: 425px
                .calendar
                    flex-basis: 33%
                    flex-shrink: 0
                    height: max-content
                    padding-right: 2rem
                    h3
                        line-height: 1.3
                        font-weight: 600
                        margin-bottom: 10px
                    ::v-deep
                        .vc-container
                            width: 100%
                            margin-bottom: 20px
                        .vc-weekday
                            height: 50px
                        .vc-day-content
                            width: 34px
                            height: 34px
                        .vc-title-layout
                            height: 50px
                        .vc-arrows-container
                            height: 64px
                        .vc-day-box-center-center
                            height: 34px
                        .vc-header
                            padding-top: 8px
                        .vc-arrow
                            width: 50px
                        .vc-day.is-not-in-month *
                            opacity: 0.2
                        .vc-container.vc-is-dark
                            background: #383837
                            border-color: #30302e
                            border-radius: 20px
                            .vc-arrow
                                border-radius: 15px
                                &:hover
                                    background: #454543
                            .vc-day-content
                                &:hover,
                                &:focus
                                    background: rgba(255,255,255, .1)

                .teasers
                    display: grid
                    grid-template-columns: 1fr 1fr
                    grid-gap: 2rem
                    width: 100%

                    +tablet-only
                        margin: 0 15px
                    +mobile
                        margin: 0 15px

                    // height: max-content
                    // .teaser
                    //     height: max-content
        .socialIcons
            padding-top: 60px
            padding-bottom: 70px
            +tablet-only
                padding-top: 30px
            +mobile
                padding-bottom: 50px
                padding-top: 20px

    .subHeadertoggleBtn
        width: 80px
        height: 80px
        background-color: #fff
        border-radius: 50%
        display: block
        position: absolute
        left: 0
        right: 0
        margin-top: -35px
        margin-left: auto
        margin-right: auto
        text-align: center
        line-height: 50px
        font-size: 40px
        &:before
            display: none
            font-family: 'Font Awesome 5 Solid'
            content: '\f0d8'
            color: $darkgray
            // transition: color .3s ease
        &:hover:before
            color: $primary
        svg
            color: inherit
            margin-right: 6px
            // transition: color .3s ease


</style>
